import type { NextRouter } from 'next/router'

import logger from '@/utils/logger'

const SAME_URL_ERROR_MESSAGE = 'Invariant: attempted to hard navigate to the same URL'

export default async function safeRouterPush({
  router,
  url,
  reloadAfterRedirect,
}: {
  router: NextRouter
  url: string
  reloadAfterRedirect: boolean
}): Promise<void> {
  try {
    await router.push(url, undefined, { shallow: false })
    if (reloadAfterRedirect) {
      router.reload()
    }
  } catch (err) {
    const shouldAttemptReload =
      err?.message != null && `${err.message}`.includes(SAME_URL_ERROR_MESSAGE)

    logger.error('Error redirecting to route', { err, shouldAttemptReload })

    if (shouldAttemptReload) {
      globalThis.location.reload()
    }
  }
}
